import * as tslib_1 from "tslib";
import './field.less';
import m from 'mithril';
import classnames from 'classnames';
import { Component } from '../component';
import { getErrorMessage } from '../../util/formutils';
var Field = /** @class */ (function (_super) {
    tslib_1.__extends(Field, _super);
    function Field() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.className = _this.attrs.unstyled ? 'field' : 'field-front';
        return _this;
    }
    Field.prototype.view = function () {
        var _a = this.attrs, errors = _a.errors, id = _a.id, required = _a.required, _b = _a.width, width = _b === void 0 ? 1.0 : _b;
        var style = { width: width * 100 + "%" };
        var hasErrors = errors !== undefined;
        var classes = [hasErrors && 'has-error', required && 'is-required'];
        return m("div." + this.className, { class: classnames(classes), style: style, id: id }, [
            this.viewLabel(),
            this.children,
            this.viewErrors()
        ]);
    };
    Field.prototype.viewLabel = function () {
        var label = this.attrs.label;
        if (!label)
            return;
        return m("div." + this.className + "-label", label);
    };
    Field.prototype.viewErrors = function () {
        var errors = this.attrs.errors;
        var hasErrors = errors !== undefined;
        if (!hasErrors)
            return;
        return m("div." + this.className + "-errormsg", getErrorMessage(errors));
    };
    return Field;
}(Component));
export { Field };
